import auth from '@/redux/auth/reducer';
import user from '@/redux/user/reducer';
import campaign from '@/redux/campaign/reducer';
import challenges from '@/redux/challenges/reducer';

import { type Reducer, combineReducers } from 'redux';

export default combineReducers({ auth, user, campaign, challenges }) as Reducer;
